import React, { useContext } from 'react';

import { useFieldArray } from 'react-final-form-arrays';

import { InputWithField, INPUT_TYPE_DATE } from 'components/Input';
import { BENEFICIARY_BIRTHDAY, BENEFICIARY_OWNER } from 'modules/Inquiry/Form/formFields';
import CalendarIcon from 'theme/components/Icon/CalendarIcon';

import { FieldValue } from '../BeneficiaryOwners/BeneficiaryOwners';
import { BeneficiaryOwnersContext } from '../BeneficiaryOwners/BeneficiaryOwners.context';

const BeneficiaryBirthdate: React.FC = () => {
  const { fieldName, userIndex } = useContext(BeneficiaryOwnersContext);
  const { fields } = useFieldArray<FieldValue>(BENEFICIARY_OWNER);
  const shouldBeDisabled = fields.value[userIndex]?.isAssociatedPerson;
  return (
    <InputWithField
      name={`${fieldName}.${BENEFICIARY_BIRTHDAY}`}
      sideSymbol={() => <CalendarIcon boxSize={6} />}
      disabled={shouldBeDisabled}
      type={INPUT_TYPE_DATE}
    />
  );
};

export default BeneficiaryBirthdate;
